import type { SVGProps } from 'react';
const DawnFlagBI = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BI_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-BI_svg__a)">
      <path fill="#E4233B" d="M0 0h22v16H0z" />
      <path
        fill="#34CD4E"
        fillRule="evenodd"
        d="m0 0 9.429 8L0 16zM22 0l-9.429 8L22 16z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m8.672 5.115-9.68-6.648L-2.18.235 7.5 6.883a3.8 3.8 0 0 0 0 2.234l-9.68 6.647 1.172 1.77 9.68-6.649a3.61 3.61 0 0 0 4.655 0l9.68 6.648 1.172-1.769-9.68-6.647a3.8 3.8 0 0 0 0-2.234L24.18.235l-1.172-1.768-9.68 6.648a3.61 3.61 0 0 0-4.655 0"
        clipRule="evenodd"
      />
      <path
        fill="#DF2239"
        fillRule="evenodd"
        d="m11 6.933-.741.221.217-.754-.217-.754.74.22.742-.22-.217.754.217.754zM9.428 9.6l-.74.22.216-.753-.216-.755.74.221.741-.22-.217.754.217.754zm2.402.22.741-.22.74.22-.216-.753.217-.755-.74.221-.742-.22.217.754z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagBI;
